import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const data = [
  {
    name: 'Th+(early)/IPTG+',
    fluorescence: 2040,
  },
  {
    name: 'Th+(late)/IPTG+',
    fluorescence: 1518,
  },
  {
    name: 'Negative Control',
    fluorescence: 1772,
  },
];



function Figure1() {
  return (
    <div>
      <br></br>
      <u>Figure 1: Measure of GFP fluorescence for varying  
      </u>
      <BarChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="fluorescence" fill="#e29aff" label={{ position: 'top' }}/>
      </BarChart>
    </div>
  );
}

export default Figure1;
